import { Component, resolveForwardRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdHocInstructionDTO } from 'src/app/core/Dtos/ad-hoc/adhoc-instruction-dto';
import { AlertLevel, AlertMessage } from 'src/app/core/Dtos/alert.entity';
import { Assets } from 'src/app/core/Dtos/assets-enum';
import { FileAttachmentDTO } from 'src/app/core/Dtos/file-attachment-dto';
import { AdHocInstructionsService } from 'src/app/core/services/ad-hoc-instructions.service';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { GeneralDataService } from 'src/app/core/services/general-data.service';

@Component({
    selector: 'app-ad-hoc',
    templateUrl: './ad-hoc.component.html',
    styleUrl: './ad-hoc.component.scss',
    standalone: false
})
export class AdHocComponent {
  public BMUList: string[] = [];
  public Instruction: AdHocInstructionDTO = new AdHocInstructionDTO();
  public FileToUpload: File | null = null;

  public Asset: Assets;
  public Assets = Assets; // Export enum to UI

  private _filesToUpload: File[] = [];
  constructor(
    private _generalDataService: GeneralDataService,
    private _adhocService: AdHocInstructionsService,
    private _activatedRoute: ActivatedRoute,
    private _alertService: AlertsService,
    private _router: Router
  ) {
    this.Asset = Assets.FirstHydro;

    if (_activatedRoute.snapshot.routeConfig?.path?.indexOf("moweo") != -1)
      this.Asset = Assets.MorayEast;
    else if (_activatedRoute.snapshot.routeConfig?.path?.indexOf("fhc") != -1)
      this.Asset = Assets.FirstHydro;
    else if (_activatedRoute.snapshot.routeConfig?.path?.indexOf("mowwl") != -1)
      this.Asset = Assets.MorayWest;
    else if (_activatedRoute.snapshot.routeConfig?.path?.indexOf("res") != -1)
      this.Asset = Assets.Res;

    let id = _activatedRoute.snapshot.paramMap.get("id");

    _generalDataService.GetBMUs(this.Asset).subscribe(
      resp => {
        this.BMUList = resp;
        // E. PRETTI - GIGU - 1634. FHC must have option for "All Units" 
        if (this.Asset == Assets.FirstHydro)
          this.BMUList.unshift("All Units");

        if (id !== null)
          this.GetInstruction(parseInt(id));
      }
    );
  }

  GetInstruction(id: number) {
    this._adhocService.GetInstructionById(id).subscribe(
      resp => {
        this.Instruction = resp;
        this.Instruction.files = [];
      }
    )
  }

  public SaveInstruction() {
    if (!this.ValidateInstruction())
      return;

    if (this.Instruction.issuedTo == "")
      this.Instruction.issuedTo = null;

    if (this._filesToUpload.length > 0)
      this._adhocService.SaveInstructionsWithAttachments(this.Asset, this.Instruction, this._filesToUpload).subscribe(
        resp => this.Cancel()
      );
    else
      this._adhocService.SaveInstruction(this.Asset, this.Instruction).subscribe(
        resp => this.Cancel()
      );
  }

  private ValidateInstruction(): boolean
  {
    let sErr:string[] = [];

    if ((this.Instruction.units ?? "") == "")
      sErr.push("Affected Unit/s");
    if ((this.Instruction.issuedFrom ?? "") == "")
      sErr.push("Issued From");
    if ((this.Instruction.subject ?? "") == "")
      sErr.push("Subject");

    if (sErr.length != 0)
    {
      this._alertService.ShowAlert(new AlertMessage(AlertLevel.Error, `The following fields are missing: \n\r ${sErr.join(", ")} `));
      return false;
    }
    return true;
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.FileToUpload = file;
    }
  }

  public AddFile() {
    if (this.FileToUpload == null) {
      this._alertService.ShowAlert(new AlertMessage(AlertLevel.Warning, "No file selected"));
      return;
    }

    this.Instruction.files.push({ fileId: "", fileName: this.FileToUpload.name });
    this._filesToUpload.push(this.FileToUpload);
    this.FileToUpload = null;
  }

  DownloadFile(fileId: number | string, fileName: string) {
    this._adhocService.DownloadFile(+fileId).subscribe(
      response => {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style.display = 'none';

        const contentType = response.headers.get('Content-Type') || 'application/octet-stream';
        const contentDisposition = response.headers.get('Content-Disposition');

        let filename = 'default-file';
        if (fileName) {
          filename = fileName;
        }


        //create a blob from the response body
        const blob = new Blob([response.body], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        //set the download URL  and filename
        a.href = url;
        a.download = filename;
        a.click();

        //clean up url object
        window.URL.revokeObjectURL(url);
      },
      err => {
        this._alertService.ShowAlert(err);
      }
    )
  }

  public RemoveFile(atIndex: number) {
    let ix: number = this._filesToUpload.findIndex(fu => fu.name == this.Instruction.files[atIndex].fileName)
    if (ix != -1)
      this._filesToUpload.splice(ix, 1);

    this.Instruction.files.splice(atIndex, 1);
  }

  public Cancel() {
    const navigateTo: string = this.Asset == Assets.MorayEast ? "moweo" :
      this.Asset == Assets.MorayWest ? "mowwl" :
      this.Asset == Assets.FirstHydro ? "fhc" :
      this.Asset == Assets.Retail ? "retail" : 
      this.Asset == Assets.Res ? "res" : "";
    this._router.navigate([navigateTo]);
  }
}
